import { render, staticRenderFns } from "./formNameStyle.vue?vue&type=template&id=70716668&scoped=true"
import script from "./formNameStyle.vue?vue&type=script&lang=js"
export * from "./formNameStyle.vue?vue&type=script&lang=js"
import style0 from "./formNameStyle.vue?vue&type=style&index=0&id=70716668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70716668",
  null
  
)

export default component.exports